import { User } from "../domain/User";

interface ClockChange {
    timestamp: Date | string; // Acepta tanto Date como string
    type: string;
    justification: string;
    state: string; // 'pending' | 'validated' | 'rejected'
    admin_uuid: string | null;
    approval_date: Date | null;
    location: string;
}

export class Clock {
    uuid: string
    timestamp: Date;
    type: string
    changes: ClockChange[];
    ui_show_changes: boolean
    user: User;
    sendEmailNotification: boolean;
    location: string;

    constructor(uuid: string, timestamp: Date, type: string, user: User, changes: ClockChange[] = [], sendEmailNotification: boolean, location: string = 'office') {
        if(changes.length == 0){
            this.changes = [{
                timestamp,
                type,
                justification: '',
                state: 'validated',
                admin_uuid: null,
                approval_date: null,
                location: location,
            }];
        }
        else{
            this.changes = changes;
        }
        this.uuid = uuid;
        this.timestamp = timestamp;
        this.type = type;
        this.ui_show_changes = false;
        this.user = user;
        this.sendEmailNotification = sendEmailNotification;
        this.location = location;
    }

    toPrimitive() {
        return {
            uuid: this.uuid,
            timestamp: this.timestamp.toISOString(),
            type: this.type,
            location: this.location,
            changes: this.changes
        };
    }

    clone() {
        return new Clock(
            this.uuid,
            this.timestamp,
            this.type,
            this.user,
            this.changes,
            this.sendEmailNotification,
            this.location
        )
    }
}